module.exports = __webpack_public_path__ + "img/anuenciaCons.274e6c52.jpg";